<template>
  <v-container fluid>
    <the-slider></the-slider>
    <v-row class="mt-2" v-if="loadingDashboard">
      <v-col cols="12" sm="4" md="4" lg="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-three-line" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mt-2" v-if="!!dashboardData && !loadingDashboard">
      <v-col cols="12" md="4" v-if="!!dashboardData.oportunidades_geradas">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{dashboardData.oportunidades_geradas.oportunidades}}</div>
              <div class="text-h3 mb-2">Propostas geradas no mês</div>
              <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(dashboardData.oportunidades_geradas.valor_total)}}</div>
              <div class="text-h3 mb-2">Em Propostas geradas no mês</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>handshake</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" v-if="!!dashboardData.oportunidades_vendidas">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{dashboardData.oportunidades_vendidas.oportunidades}}</div>
              <div class="text-h3 mb-2">Propostas vendidas no mês</div>
              <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(dashboardData.oportunidades_vendidas.valor_total)}}</div>
              <div class="text-h3 mb-2">Em Propostas vendidas no mês</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>monetization_on</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" v-if="!!dashboardData.potencia_vendida">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{dashboardData.potencia_vendida.mes}}kWp</div>
              <div class="text-h3 mb-2">Vendidos no mês</div>
              <div class="text-h1 mb-2">{{dashboardData.potencia_vendida.total}}kWp</div>
              <div class="text-h3 mb-2">Total vendido</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>energy_savings_leaf</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <lista-tarefas :dataInicio="dataInicio" :dataFim="dataFim" :disableDatePicker="true"></lista-tarefas>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import TheSlider from '@components/TheSlider.vue'
import ListaTarefas from './tarefas/ListaTarefas.vue'

export default {
  components: {
    TheSlider,
    ListaTarefas
  },
  data () {
    return {
      loadingDashboard: false,
      dashboardData: null,
      dataInicio: moment().format('YYYY-MM-DD'),
      dataFim: moment().add(7, 'day').format('YYYY-MM-DD')
    }
  },
  methods: {
    async getDashboardData () {
      this.loadingDashboard = true
      await Api.get('dashboard')
        .then(res => {
          if (res.data) {
            this.dashboardData = res.data
          }
          this.loadingDashboard = false
        })
        .catch(err => {
          this.loadingDashboard = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as informações do dashboard!',
            color: 'error'
          })
          console.log(err)
        })
    },
    loadFunctions () {
      this.getDashboardData()
    },
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue